import R from 'ramda';
import { createSelector } from 'reselect';

const root = state => state.marathons;

export const getLanguages = state => root(state).languages;
export const getReviews = state => root(state).reviews;
export const getShowFullSelector = state => root(state).showFullSelector;
export const getShowRegistration = state => root(state).showRegistration;
export const getCurrentLanguage = state => root(state).currentLanguage;
export const getCurrentWay = state => root(state).currentWay;

const getCurrentLanguageData = createSelector(
    [getCurrentLanguage, getLanguages],
    (currentLanguage, languages) => R.find(item => item.code === currentLanguage, languages) || {}
);

export const getCurrentLanguagePaymentUrl = state => getCurrentLanguageData(state).payment_url;
export const getCurrentLanguageId = state => getCurrentLanguageData(state).id;
export const getCurrentMarathonUrl = state => getCurrentLanguageData(state).url;

export const getLanguagesOptions = createSelector(
    getLanguages,
    R.map(item => ({ key: item.code, value: item.full_name }))
);

export const getData = state => root(state).data;

const getRegistration = state => root(state).registration;
export const getIsFormSubmitting = state => !!getRegistration(state).pending;
export const getRegistrationErrors = state => getRegistration(state).errors;



// WEBPACK FOOTER //
// ./src/marathons/selectors.js